import React, { Component } from 'react';
import { Group, Path } from 'react-konva';
// import {Image as KonvaImage} from "react-konva/lib/ReactKonvaCore";

class SvgSticker extends Component {
  render() {
    //console.log(this.props.props);
    return (
      <Group name={this.props.name} scaleX={this.props.props.scaleX} scaleY={this.props.props.scaleY} onTransformEnd={this.props.onTransformEnd} draggable={this.props.draggable || false} onDragEnd={this.props.onDragEnd} x={this.props.props.x} y={this.props.props.y}>
        {this.props.object.paths.map((data, i) => {
          const pathProps = {
            width: this.props.props.width,
            height: this.props.props.height,
            scaleX: 1,
            scaleY: 1,
            fill: this.props.props.fill,
          };

          return (
            <Path draggable={false} key={this.props.name + i} data={data} {...pathProps} />
          );
        })}
      </Group>
    );
  }
}

export default SvgSticker;


// WEBPACK FOOTER //
// ./src/components/SvgSticker.js